<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <billing-address-form />
  </v-container>
</template>

<script>
import BillingAddressForm from './_Form'

export default {
  name: 'DriverMasterBillingAddressEdit',
  components: {
    BillingAddressForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: '請求先一覧', disabled: false, to: '/driver/masters/billing_addresses', exact: true },
        { text: '請求先編集', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>
